export default {
  betegellato: {
    pecsetszam: {
      key: 'pecsetszam',
      type: 'text',
      label: 'Az ellátó orvos pecsétszáma',
      validation: [{required: true}, {onlyNumber: true}, {exactLength: 5}],
      dependency: null
    },
    osztaly: {
      key: 'osztaly',
      type: 'text',
      label: 'Az ellátó osztály ÁNTSZ kódja',
      validation: [{required: true}, {onlyNumber: true}, {exactLength: 9}],
      dependency: null
    }
  },
  beteg: {
    beteg_nev: {
      key: 'beteg_nev',
      type: 'text',
      label: 'A beteg neve',
      validation: [{maxLength: 100}, {required: true}],
      dependency: null
    },
    szuletesi_nev: {
      key: 'szuletesi_nev',
      type: 'text',
      label: 'A beteg születési neve',
      recommended: true,
      validation: [{maxLength: 100}],
      dependency: null
    },
    anyja_neve: {
      key: 'anyja_neve',
      type: 'text',
      label: 'A beteg anyjának születési neve',
      recommended: true,
      validation: [{maxLength: 100}],
      dependency: [{hasContent: 'szuletesi_nev'}]
    },
    szuletesi_datum: {
      key: 'szuletesi_datum',
      type: 'date',
      label: 'A beteg születési dátuma',
      validation: [{type: 'date'}, {required: true}],
      dependency: null
    },
    szuletesi_hely: {
      key: 'szuletesi_hely',
      type: 'text',
      label: 'A beteg születési helye',
      recommended: true,
      validation: [{maxLength: 100}],
      dependency: null
    },
    iranyitoszam: {
      key: 'iranyitoszam',
      type: 'text',
      label: 'A beteg lakóhelye: irányítószám',
      validation: [{type: 'number'}, {maxLength: 6}, {required: true}],
      dependency: null
    },
    cim: {
      key: 'cim',
      type: 'text',
      label: 'A beteg lakóhelye: cím többi része',
      recommended: true,
      validation: [{maxLength: 100}],
      dependency: null
    },
    nem: {
      key: 'nem',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'A beteg neme',
      validation: [{required: true}, {type: 'number'}],
      dependency: null
    },
    taj: {
      key: 'taj',
      type: 'text',
      label: 'A beteg TAJ száma',
      validation: [{required: true}, {onlyNumber: true}, {exactLength: 9}],
      dependency: null
    },
  },
  betegseg_alap: {
    ellatas_id: {
      key: 'ellatas_id',
      type: 'text',
      label: 'Az ellatas azonosítója (törzsszáma, naplósorszám) az ellátó intézménynél',
      validation: [{required: true}, {maxLength: 30}],
      dependency: null
    },
    ellatas_tipusa: {
      key: 'ellatas_tipusa',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'Az ellátás típusa (járó-/fekvőbeteg)',
      validation: [{required: true}],
      dependency: null
    },
    megjelenes_datum: {
      key: 'megjelenes_datum',
      type: 'date',
      label: 'A jelentett esemény dátuma az ellátó intézménynél',
      validation: [{required: true}, {type: 'date'}],
      dependency: null
    },
    bno: {
      key: 'bno',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'A betegség BNO10 kódja',
      validation: [{required: true}, {maxLength: 5}],
      dependency: null
    },
    bno_datum: {
      key: 'bno_datum',
      type: 'date',
      label: 'A megállapításának időpontja',
      recommended: true,
      validation: [{type: 'date'}],
      dependency: [{hasContent: 'bno'}]
    },
    who: {
      key: 'who',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'Az ellátáshoz tartozó WHO kód',
      validation: [{maxLength: 10}, {required: true}],
      dependency: [{bno: ['AL', 'HL', 'NHL']}]
    },
    who_datum: {
      key: 'who_datum',
      type: 'date',
      label: 'Az ellátáshoz tartozó időpont',
      recommended: true,
      validation: [{type: 'date'}],
      dependency: [{hasContent: 'who'}]
    },
    mcode: {
      key: 'mcode',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'A morfológiai kód',
      validation: [{required: true}],
      dependency: null
    },
    mcode_datum: {
      key: 'mcode_datum',
      type: 'date',
      label: 'A kód megállapításának időpontja',
      recommended: true,
      validation: [{type: 'date'}],
      dependency: [{hasContent: 'mcode'}]
    },
    ecog_statusz: {
      key: 'ecog_statusz',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'ECOG státusz kódja (0-5)',
      validation: [{required: true}],
      dependency: null
    }
  },
  betegseg_reszletek: {
    kezeles: {
      kontrollvizsgalat: {
        key: 'kontrollvizsgalat',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'A kontrollvizsgálat kódja',
        validation: null,
        dependency: null
      },
      aktiv_kezeles: {
        key: 'aktiv_kezeles',
        type: 'three_state',
        label: 'Aktív kezelés történt?',
        recommended: true,
        validation: null,
        dependency: null
      },
      aktiv_kezeles_betegsegspec_mut: {
        key: 'aktiv_kezeles_betegsegspec_mut',
        type: 'three_state',
        label: 'Aktív kezelés: betegségspecifikus műtét történt?',
        validation: null,
        dependency: [{hasContent: 'aktiv_kezeles'}, {elementsOf: ['aktiv_kezeles', [2]] }]
      },
      aktiv_kezeles_kemoterapia: {
        key: 'aktiv_kezeles_kemoterapia',
        type: 'three_state',
        label: 'Aktív kezelés: kemoterápia történt?',
        validation: null,
        dependency: [{hasContent: 'aktiv_kezeles'}, {elementsOf: ['aktiv_kezeles', [2]] }]
      },
      aktiv_kezeles_immunoterapia: {
        key: 'aktiv_kezeles_immunoterapia',
        type: 'three_state',
        label: 'Aktív kezelés: immunoterápia történt?',
        validation: null,
        dependency: [{hasContent: 'aktiv_kezeles'}, {elementsOf: ['aktiv_kezeles', [2]] }]
      },
      aktiv_kezeles_kemo_immunot: {
        key: 'aktiv_kezeles_kemo_immunot',
        type: 'three_state',
        label: 'Aktív kezelés: kemo-immunoterápia történt?',
        validation: null,
        dependency: [{hasContent: 'aktiv_kezeles'}, {elementsOf: ['aktiv_kezeles', [2]] }]
      },
      aktiv_kezeles_sugarkezeles: {
        key: 'aktiv_kezeles_sugarkezeles',
        type: 'three_state',
        label: 'Aktív kezelés: sugárkezelés történt?',
        validation: null,
        dependency: [{hasContent: 'aktiv_kezeles'}, {elementsOf: ['aktiv_kezeles', [2]] }]
      },
      aktiv_kezeles_ossejt_transzpl: {
        key: 'aktiv_kezeles_ossejt_transzpl',
        type: 'three_state',
        label: 'Aktív kezelés: őssejt transzplantáció történt?',
        validation: null,
        dependency: [{hasContent: 'aktiv_kezeles'}, {elementsOf: ['aktiv_kezeles', [2]] }]
      },
      aktiv_kezeles_jelatvitel_gatlo: {
        key: 'aktiv_kezeles_jelatvitel_gatlo',
        type: 'three_state',
        label: 'Aktív kezelés: jelátvitel gátló kezelés történt?',
        validation: null,
        dependency: [{hasContent: 'aktiv_kezeles'}, {elementsOf: ['aktiv_kezeles', [2]] }]
      },
      szupportiv_kezeles: {
        key: 'szupportiv_kezeles',
        type: 'three_state',
        label: 'Szupportív kezelés történt?',
        recommended: true,
        validation: null,
        dependency: null
      },
      szupportiv_kezeles_bet_szov_kez: {
        key: 'szupportiv_kezeles_bet_szov_kez',
        type: 'three_state',
        label: 'Szupportív kezelés: betegség vagy szövődménye miatti kezelés történt?',
        validation: null,
        dependency: [{hasContent: 'szupportiv_kezeles'}, {elementsOf: ['szupportiv_kezeles', [2]] }]
      },
      szupportiv_kezeles_kor_kez_szov: {
        key: 'szupportiv_kezeles_kor_kez_szov',
        type: 'three_state',
        label: 'Szupportív kezelés: korábbi kezelés szövődménye miatti kezelés történt?',
        validation: null,
        dependency: [{hasContent: 'szupportiv_kezeles'}, {elementsOf: ['szupportiv_kezeles', [2]] }]
      },
      szupportiv_kezeles_infekcio: {
        key: 'szupportiv_kezeles_infekcio',
        type: 'three_state',
        label: 'Szupportív kezelés: infekció kezelése történt?',
        validation: null,
        dependency: [{hasContent: 'szupportiv_kezeles'}, {elementsOf: ['szupportiv_kezeles', [2]] }]
      },
      szupportiv_kezeles_transzfuzio: {
        key: 'szupportiv_kezeles_transzfuzio',
        type: 'three_state',
        label: 'Szupportív kezelés: transzfúziós kezelés történt?',
        validation: null,
        dependency: [{hasContent: 'szupportiv_kezeles'}, {elementsOf: ['szupportiv_kezeles', [2]] }]
      },
      kezelesi_szovodmeny: {
        key: 'kezelesi_szovodmeny',
        type: 'three_state',
        label: 'Kezelési szövődmény jelen volt?',
        recommended: true,
        validation: null,
        dependency: null
      },
      kezelesi_szov_allergia: {
        key: 'kezelesi_szov_allergia',
        type: 'three_state',
        label: 'Kezelési szövődmény: allergia jelen volt?',
        validation: null,
        dependency: [{hasContent: 'kezelesi_szovodmeny'}, {elementsOf: ['kezelesi_szovodmeny', [2]] }]
      },
      kezelesi_szov_lysis_szindroma: {
        key: 'kezelesi_szov_lysis_szindroma',
        type: 'three_state',
        label: 'Kezelési szövődmény: lysis szindróma jelen volt?',
        validation: null,
        dependency: [{hasContent: 'kezelesi_szovodmeny'}, {elementsOf: ['kezelesi_szovodmeny', [2]] }]
      },
      kezelesi_szov_szervelegtelenseg: {
        key: 'kezelesi_szov_szervelegtelenseg',
        type: 'three_state',
        label: 'Kezelési szövődmény: szervelégtelenség jelen volt?',
        validation: null,
        dependency: [{hasContent: 'kezelesi_szovodmeny'}, {elementsOf: ['kezelesi_szovodmeny', [2]] }]
      },
      kezelesi_szov_infekcio: {
        key: 'kezelesi_szov_infekcio',
        type: 'three_state',
        label: 'Kezelési szövődmény: infekció jelen volt?',
        validation: null,
        dependency: [{hasContent: 'kezelesi_szovodmeny'}, {elementsOf: ['kezelesi_szovodmeny', [2]] }]
      },
      kezelesi_szov_egyeb: {
        key: 'kezelesi_szov_egyeb',
        type: 'three_state',
        label: 'Kezelési szövődmény: egyéb szövődmény jelen volt? (ha igen, a Kezelési szövődmény: egyéb szövődmény szöveges leírása mezőben szövegesen meghatározható)',
        validation: null,
        dependency: [{hasContent: 'kezelesi_szovodmeny'}, {elementsOf: ['kezelesi_szovodmeny', [2]] }]
      },
      kezelesi_szov_egyeb_szoveges: {
        key: 'kezelesi_szov_egyeb_szoveges',
        type: 'text',
        label: 'Kezelési szövődmény: egyéb szövődmény szöveges leírása',
        validation: [{maxLength: 400}],
        dependency: [{hasContent: 'kezelesi_szov_egyeb'}, {elementsOf: ['kezelesi_szov_egyeb', [2]] }]
      },
      kezelesi_szov_halal: {
        key: 'kezelesi_szov_halal',
        type: 'three_state',
        label: 'Kezelési szövődmény: a beteg elhunyt?',
        validation: null,
        dependency: [{hasContent: 'kezelesi_szovodmeny'}, {elementsOf: ['kezelesi_szovodmeny', [2]] }]
      }
    },
    reszletek: {
      ann_arbor_stadium: {
        key: 'ann_arbor_stadium',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Ann-Arbor stádium aktuális észleléskor',
        recommended: true,
        validation: [{hasContent: 'ann_arbor_modosito'}],
        validationText: 'Ann-Arbor módosító mezőt is ki kell tölteni!',
        dependency: [{bno: ['HL', 'NHL']}]
      },
      ann_arbor_kiegeszito: {
        key: 'ann_arbor_kiegeszito',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Ann-Arbor kiegészítő aktuális észleléskor',
        recommended: true,
        validation: [{hasContent: 'ann_arbor_stadium'}, {hasContent: 'ann_arbor_modosito'}],
        validationText: 'Ann-Arbor módosító mezőt is ki kell tölteni!',
        dependency: [{hasContent: 'ann_arbor_stadium'}]
      },
      ann_arbor_modosito: {
        key: 'ann_arbor_modosito',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Ann-Arbor módosító aktuális észleléskor',
        recommended: true,
        validation: [{hasContent: 'ann_arbor_stadium'}, {required: true}],
        validationText: 'Kötelező mező',
        dependency: [{hasContent: 'ann_arbor_stadium'}]
      },
      ann_arbor_stadium_lugano: {
        key: 'ann_arbor_stadium_lugano',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Ann-Arbor stádium (Lugano modifikált) aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [{bno: ['HL', 'NHL']}]
      },
      nccn_prognozis: {
        key: 'nccn_prognozis',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'NCCN prognózis kódja aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [{bno: ['HL']}]
      },
      eortc_prognozis: {
        key: 'eortc_prognozis',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'EORTC prognózis kódja aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [{bno: ['HL']}]
      },
      flipi_1: {
        key: 'flipi_1',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'FLIPI-1 besorolás kódja aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8290", "C8270", "C8220", "C8210", "C8200"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1594", "1595", "1596", "1597", "1598", "1599", "1600",
                    "1601", "1602", "1603", "1604", "1605",
                    "1606", "1607", "1608", "1609",
                    "1610", "1611", "1612", "1613", "1614", "1615", "1616", "1617", "1618", "1619"
                  ]
                ]
              }
            ]
          }
        ]
      },
      flipi_2: {
        key: 'flipi_2',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'FLIPI-2 besorolás kódja aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8290", "C8270", "C8220", "C8210", "C8200"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1594", "1595", "1596", "1597", "1598", "1599", "1600",
                    "1601", "1602", "1603", "1604", "1605",
                    "1606", "1607", "1608", "1609",
                    "1610", "1611", "1612", "1613", "1614", "1615", "1616", "1617", "1618", "1619"
                  ]
                ]
              }
            ]
          }
        ]
      },
      kk_limfoma_altal_ok_tunetek: {
        key: 'kk_limfoma_altal_ok_tunetek',
        type: 'three_state',
        label: 'Kezelési (módosított GELF) kritériumok: a lymphoma által okozott tünetek (közöttük a B-tünetek, vérzés, teltségérzés) ',
        validation: null,
        dependency: [{hasContent: 'mcode'}, {elementsOf: ['mcode', ["1591", "1592", "1593", "1620", "1621", "1622", "1623", "1624", "1625", "1626", "1627", "1628", "1629", "1630"]] }]
      },
      kk_kezelendo_szervfunkcios_zav: {
        key: 'kk_kezelendo_szervfunkcios_zav',
        type: 'three_state',
        label: 'Kezelési (módosított GELF) kritériumok: kezelendő szervfunkciós zavar',
        validation: null,
        dependency: [{hasContent: 'mcode'}, {elementsOf: ['mcode', ["1591", "1592", "1593", "1620", "1621", "1622", "1623", "1624", "1625", "1626", "1627", "1628", "1629", "1630"]] }]
      },
      kk_limfoma_altal_ok_cytopenia: {
        key: 'kk_limfoma_altal_ok_cytopenia',
        type: 'three_state',
        label: 'Kezelési (módosított GELF) kritériumok: a lymphoma által okozott cytopenia (fvs < 1.0 G/l és/vagy tct < 100 G/l) ',
        validation: null,
        dependency: [{hasContent: 'mcode'}, {elementsOf: ['mcode', ["1591", "1592", "1593", "1620", "1621", "1622", "1623", "1624", "1625", "1626", "1627", "1628", "1629", "1630"]] }]
      },
      kk_bulky_betegseg: {
        key: 'kk_bulky_betegseg',
        type: 'three_state',
        label: 'Kezelési (módosított GELF) kritériumok: bulky betegség',
        validation: null,
        dependency: [{hasContent: 'mcode'}, {elementsOf: ['mcode', ["1591", "1592", "1593", "1620", "1621", "1622", "1623", "1624", "1625", "1626", "1627", "1628", "1629", "1630"]] }]
      },
      kk_splenomegalia: {
        key: 'kk_splenomegalia',
        type: 'three_state',
        label: 'Kezelési (módosított GELF) kritériumok: splenomegalia ',
        validation: null,
        dependency: [{hasContent: 'mcode'}, {elementsOf: ['mcode', ["1591", "1592", "1593", "1620", "1621", "1622", "1623", "1624", "1625", "1626", "1627", "1628", "1629", "1630"]] }]
      },
      kk_folyamatos_progresszio: {
        key: 'kk_folyamatos_progresszio',
        type: 'three_state',
        label: 'Kezelési (módosított GELF) kritériumok: legalább 6 hónapig folyamatos progresszió',
        validation: null,
        dependency: [{hasContent: 'mcode'}, {elementsOf: ['mcode', ["1591", "1592", "1593", "1620", "1621", "1622", "1623", "1624", "1625", "1626", "1627", "1628", "1629", "1630"]] }]
      },
      gastrointestinalis_malt_limf_stad: {
        key: 'gastrointestinalis_malt_limf_stad',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Gastrointestinalis MALT lymphoma stádium aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [{hasContent: 'mcode'}, {elementsOf: ['mcode', ["1591", "1592", "1593", "1620", "1621", "1622", "1623", "1624", "1625", "1626", "1627", "1628", "1629", "1630"]] }]
      },
      extranodalis_erintettseg: {
        key: 'extranodalis_erintettseg',
        type: 'text',
        label: 'Extranodalis érintettség helye',
        validation: [{maxLength: 400}],
        dependency: [{bno: ['HL', 'NHL']}]
      },
      extraossealis_erintettseg: {
        key: 'extraossealis_erintettseg',
        type: 'text',
        label: 'Extraossealis érintettség helye',
        validation: [{maxLength: 400}],
        dependency: [{bno: ['MM']}]
      },
      extramedullaris_erintettseg: {
        key: 'extramedullaris_erintettseg',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Extramedullaris érintettség jellege',
        recommended: true,
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      extramed_lok_bor_lagyresz: {
        key: 'extramed_lok_bor_lagyresz',
        type: 'three_state',
        label: 'Extramedullaris érintettség: bőr/lágyrész érintett?',
        validation: null,
        dependency: [{hasContent: 'extramedullaris_erintettseg'}, {elementsOf: ['extramedullaris_erintettseg', ["2", "3", "4"]] }]
      },
      extramed_lok_bor_lagyresz_biz: {
        key: 'extramed_lok_bor_lagyresz_biz',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Extramedullaris érintettség: bőr/lágyrész érintettségének bizonyítékának forrása',
        validation: null,
        dependency: [{hasContent: 'extramed_lok_bor_lagyresz'}, {elementsOf: ['extramed_lok_bor_lagyresz', [2]] }]
      },
      extramed_lok_idegr_erzeksz: {
        key: 'extramed_lok_idegr_erzeksz',
        type: 'three_state',
        label: 'Extramedullaris érintettség: idegrendszer/érzékszerv érintett?',
        validation: null,
        dependency: [{hasContent: 'extramedullaris_erintettseg'}, {elementsOf: ['extramedullaris_erintettseg', ["2", "3", "4"]] }]
      },
      extramed_lok_idegr_erzeksz_biz: {
        key: 'extramed_lok_idegr_erzeksz_biz',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Extramedullaris érintettség: idegrendszer/érzékszerv érintettségének bizonyítékának forrása',
        validation: null,
        dependency: [{hasContent: 'extramed_lok_idegr_erzeksz'}, {elementsOf: ['extramed_lok_idegr_erzeksz', [2]] }]
      },
      extramed_lok_maj: {
        key: 'extramed_lok_maj',
        type: 'three_state',
        label: 'Extramedullaris érintettség: máj érintett?',
        validation: null,
        dependency: [{hasContent: 'extramedullaris_erintettseg'}, {elementsOf: ['extramedullaris_erintettseg', ["2", "3", "4"]] }]
      },
      extramed_lok_maj_biz: {
        key: 'extramed_lok_maj_biz',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Extramedullaris érintettség: máj érintettségének bizonyítékának forrása',
        validation: null,
        dependency: [{hasContent: 'extramed_lok_maj'}, {elementsOf: ['extramed_lok_maj', [2]] }]
      },
      extramed_lok_vese: {
        key: 'extramed_lok_vese',
        type: 'three_state',
        label: 'Extramedullaris érintettség: vese érintett?',
        validation: null,
        dependency: [{hasContent: 'extramedullaris_erintettseg'}, {elementsOf: ['extramedullaris_erintettseg', ["2", "3", "4"]] }]
      },
      extramed_lok_vese_biz: {
        key: 'extramed_lok_vese_biz',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Extramedullaris érintettség: vese érintettségének bizonyítékának forrása',
        validation: null,
        dependency: [{hasContent: 'extramed_lok_vese'}, {elementsOf: ['extramed_lok_vese', [2]] }]
      },
      extramed_lok_tudo: {
        key: 'extramed_lok_tudo',
        type: 'three_state',
        label: 'Extramedullaris érintettség: tüdő érintett?',
        validation: null,
        dependency: [{hasContent: 'extramedullaris_erintettseg'}, {elementsOf: ['extramedullaris_erintettseg', ["2", "3", "4"]] }]
      },
      extramed_lok_tudo_biz: {
        key: 'extramed_lok_tudo_biz',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Extramedullaris érintettség: tüdő érintettségének bizonyítékának forrása',
        validation: null,
        dependency: [{hasContent: 'extramed_lok_tudo'}, {elementsOf: ['extramed_lok_tudo', [2]] }]
      },
      extramed_lok_csont_izom: {
        key: 'extramed_lok_csont_izom',
        type: 'three_state',
        label: 'Extramedullaris érintettség: csont/izom érintett?',
        validation: null,
        dependency: [{hasContent: 'extramedullaris_erintettseg'}, {elementsOf: ['extramedullaris_erintettseg', ["2", "3", "4"]] }]
      },
      extramed_lok_csont_izom_biz: {
        key: 'extramed_lok_csont_izom_biz',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Extramedullaris érintettség: csont/izom érintettségének bizonyítékának forrása',
        validation: null,
        dependency: [{hasContent: 'extramed_lok_csont_izom'}, {elementsOf: ['extramed_lok_csont_izom', [2]] }]
      },
      bulky_tumor_lokalizacioja: {
        key: 'bulky_tumor_lokalizacioja',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Bulky tumor lokalizációja (ha egyéb, akkor a Bulky tumor lokalizációja: egyéb (szövegesen megadva) mezőben megadható)',
        validation: null,
        dependency: [{bno: ['HL', 'NHL']}]
      },
      bulky_tumor_lokalizacioja_egyeb: {
        key: 'bulky_tumor_lokalizacioja_egyeb',
        type: 'text',
        label: 'Bulky tumor lokalizációja: egyéb (szövegesen megadva)',
        validation: [{maxLength: 200}],
        dependency: [{hasContent: 'bulky_tumor_lokalizacioja'}, {elementsOf: ['bulky_tumor_lokalizacioja', ["99"]] }]
      },
      ipi_score_ertek: {
        key: 'ipi_score_ertek',
        type: 'text',
        label: 'IPI score (számérték) aktuális észleléskor',
        recommended: true,
        validation: [{type: 'number'}],
        dependency: [{bno: ['HL']}]
      },
      ipi_kategoria: {
        key: 'ipi_kategoria',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'IPI kategória aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            oneOf: [
              {
                elementsOf: [
                  'mcode',
                  [
                    "1555", "1556", "1557", "1558", "1559", "1560", "1561", "1562", "1563", "1564",
                    "1565", "1566", "1567", "1568", "1569", "1570", "1571", "1572", "1573", "1574",
                    "1575", "1576", "1577", "1578", "1579", "1580", "1581", "1582"
                  ]
                ]
              },
              {
                allOf: [
                  {
                    elementsOf: [
                      'bno',
                      [
                        "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                      ]
                    ]
                  },
                  {
                    elementsOf: [
                      'mcode',
                      [
                        "1644", "1635", "1636", "1637", "1638", "1639", "1640", "1641", "1642", "1643",
                        "1645", "1646", "1647", "1648", "1657", "1658", "1659", "1660", "1661", "1664",
                        "1665", "1666"
                      ]
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      korcsoporthoz_alakitott_ipi_kat: {
        key: 'korcsoporthoz_alakitott_ipi_kat',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Korcsoporthoz alakított IPI kategória aktuális észleléskor',
        validation: null,
        dependency: [
          {
            oneOf: [
              {
                elementsOf: [
                  'mcode',
                  [
                    "1555", "1556", "1557", "1558", "1559", "1560", "1561", "1562", "1563", "1564",
                    "1565", "1566", "1567", "1568", "1569", "1570", "1571", "1572", "1573", "1574",
                    "1575", "1576", "1577", "1578", "1579", "1580", "1581", "1582"
                  ]
                ]
              },
              {
                allOf: [
                  {
                    elementsOf: [
                      'bno',
                      [
                        "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                      ]
                    ]
                  },
                  {
                    elementsOf: [
                      'mcode',
                      [
                        "1644", "1635", "1636", "1637", "1638", "1639", "1640", "1641", "1642", "1643",
                        "1645", "1646", "1647", "1648", "1657", "1658", "1659", "1660", "1661", "1664",
                        "1665", "1666"
                      ]
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      stadiumhoz_alakitott_ipi_kat: {
        key: 'stadiumhoz_alakitott_ipi_kat',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Stádiumhoz alakított IPI kategória aktuális észleléskor',
        validation: null,
        dependency: [
          {hasContent: 'mcode'},
          {
            elementsOf: [
              'mcode',
              [
                "1555", "1556", "1557", "1558", "1559", "1560", "1561", "1562", "1563", "1564",
                "1565", "1566", "1567", "1568", "1569", "1570", "1571", "1572", "1573", "1574",
                "1575", "1576", "1577", "1578", "1579", "1580", "1581", "1582"
              ]
            ]
          }
        ]
      },
      r_ipi_kategoria: {
        key: 'r_ipi_kategoria',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'R-IPI kategória aktuális észleléskor',
        validation: null,
        dependency: [{bno: ['NHL']}]
      },
      pit: {
        key: 'pit',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'PIT (nem specifikált perif. T-sejt lymphoma prognosztikus index) kategória aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1644", "1635", "1636", "1637", "1638", "1639", "1640", "1641", "1642", "1643",
                    "1645", "1646", "1647", "1648", "1657", "1658", "1659", "1660", "1661", "1664",
                    "1665", "1666"
                  ]
                ]
              }
            ]
          }
        ]
      },
      modositott_pit: {
        key: 'modositott_pit',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Módosított PIT kategória aktuális észleléskor',
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1644", "1635", "1636", "1637", "1638", "1639", "1640", "1641", "1642", "1643",
                    "1645", "1646", "1647", "1648", "1657", "1658", "1659", "1660", "1661", "1664",
                    "1665", "1666"
                  ]
                ]
              }
            ]
          }
        ]
      },
      itcl_project_kategoria: {
        key: 'itcl_project_kategoria',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'ITCL-project kategória aktuális észleléskor',
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1644", "1635", "1636", "1637", "1638", "1639", "1640", "1641", "1642", "1643",
                    "1645", "1646", "1647", "1648", "1657", "1658", "1659", "1660", "1661", "1664",
                    "1665", "1666"
                  ]
                ]
              }
            ]
          }
        ]
      },
      pink: {
        key: 'pink',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'PINK besorolás  aktuális észleléskor',
        validation: null,
        dependency: [
          {hasContent: 'mcode'},
          {elementsOf: ['mcode', ["1671", "1672", "1673", "1674", "1675", "1676", "1677"]]}
        ]
      },
      pink_e: {
        key: 'pink_e',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'PINK-E besorolás aktuális észleléskor',
        validation: null,
        dependency: [
          {hasContent: 'mcode'},
          {elementsOf: ['mcode', ["1671", "1672", "1673", "1674", "1675", "1676", "1677"]]}
        ]
      },
      tnm_besorolas_t: {
        key: 'tnm_besorolas_t',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'TNM besorolás T része aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {elementsOf: [
                'mcode',
                [
                  "1528", "1578", "1648", "1649", "1650", "1651", "1652", "1667", "1669",
                  "1670", "1680", "1701", "1702", "1626"
                ]
              ]}
            ]
          }
        ]
      },
      tnm_besorolas_n: {
        key: 'tnm_besorolas_n',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'TNM besorolás N része aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {elementsOf: [
                'mcode',
                [
                  "1528", "1578", "1648", "1649", "1650", "1651", "1652", "1667", "1669",
                  "1670", "1680", "1701", "1702", "1626"
                ]
              ]}
            ]
          }
        ]
      },
      tnm_besorolas_m: {
        key: 'tnm_besorolas_m',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'TNM besorolás M része aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {elementsOf: [
                'mcode',
                [
                  "1528", "1578", "1648", "1649", "1650", "1651", "1652", "1667", "1669",
                  "1670", "1680", "1701", "1702", "1626"
                ]
              ]}
            ]
          }
        ]
      },
      tnmb_besorolas_t: {
        key: 'tnmb_besorolas_t',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'TNMB besorolás T része aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1631", "1632", "1633", "1634"
                  ]
                ]
              }
            ]
          }
        ]
      },
      tnmb_besorolas_n: {
        key: 'tnmb_besorolas_n',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'TNMB besorolás N része aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1631", "1632", "1633", "1634"
                  ]
                ]
              }
            ]
          }
        ]
      },
      tnmb_besorolas_m: {
        key: 'tnmb_besorolas_m',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'TNMB besorolás M része aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1631", "1632", "1633", "1634"
                  ]
                ]
              }
            ]
          }
        ]
      },
      tnmb_besorolas_b: {
        key: 'tnmb_besorolas_b',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'TNMB besorolás B része aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1631", "1632", "1633", "1634"
                  ]
                ]
              }
            ]
          }
        ]
      },
      klinikai_stadium: {
        key: 'klinikai_stadium',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Klinikai stádium aktuális észleléskor',
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8450", "C8440", "C8430", "C8420", "C8410", "C8400"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1631", "1632", "1633", "1634"
                  ]
                ]
              }
            ]
          }
        ]
      },
      durie_salmon_stadium: {
        key: 'durie_salmon_stadium',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Durie-Salmon stádium aktuális észleléskor',
        recommended: true,
        validation: [{hasContent: 'durie_salmon_modosito'}],
        validationText: 'Kötelezően szám, Durie-Salmon módosító mezőt is ki kell tölteni!',
        dependency: [{bno: ['MM']}]
      },
      durie_salmon_modosito: {
        key: 'durie_salmon_modosito',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Durie-Salmon módosító aktuális észleléskor',
        recommended: true,
        validation: [{required: true}],
        dependency: [{hasContent: 'durie_salmon_stadium'}]
      },
      iss_stadium: {
        key: 'iss_stadium',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'ISS stádium aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [{bno: ['MM']}]
      },
      r_iss_stadium: {
        key: 'r_iss_stadium',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'R-ISS stádium aktuális észleléskor',
        recommended: true,
        validation: null,
        dependency: [{bno: ['MM']}]
      },
      rizikocsoport: {
        key: 'rizikocsoport',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Rizikócsoport aktuális észleléskor',
        validation: null,
        dependency: [
          {
            allOf: [
              {
                elementsOf: [
                  'bno',
                  [
                    "C8390", "C8380", "C8370", "C8360", "C8350", "C8340", "C8330", "C8320", "C8310", "C8300"
                  ]
                ]
              },
              {
                elementsOf: [
                  'mcode',
                  [
                    "1583", "1584", "1585", "1586", "1587"
                  ]
                ]
              }
            ]
          }
        ]
      },
      binet_stadium: {
        key: 'binet_stadium',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Klinikai (Binet) stádium diagnóziskor',
        recommended: true,
        validation: null,
        dependency: [{bno: ['CLL']}]
      },
      aktualis_laz: {
        key: 'aktualis_laz',
        type: 'three_state',
        label: 'Aktuális láz van-e?',
        recommended: true,
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      aktualis_laz_oka: {
        key: 'aktualis_laz_oka',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Aktuális láz oka',
        validation: null,
        dependency: [{hasContent: 'aktualis_laz'}, {elementsOf: ['aktualis_laz', [2]] }]
      },
      aktualis_laz_infekcio: {
        key: 'aktualis_laz_infekcio',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Aktuális láz: infekció lokalizálható?',
        validation: null,
        dependency: [{hasContent: 'aktualis_laz_oka'}, {elementsOf: ['aktualis_laz_oka', ["2"]] }]
      },
      aktualis_laz_lokalizalhato: {
        key: 'aktualis_laz_lokalizalhato',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Aktuális láz: infekció lokalizációjának alapja',
        validation: null,
        dependency: [{hasContent: 'aktualis_laz_infekcio'}, {elementsOf: ['aktualis_laz_infekcio', ["2"]] }]
      },
      aktualis_laz_igazolas: {
        key: 'aktualis_laz_igazolas',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Aktuális láz: nem lokalizálható infekció esetén az igazolás típusa',
        validation: null,
        dependency: [{hasContent: 'aktualis_laz_infekcio'}, {elementsOf: ['aktualis_laz_infekcio', ["3"]] }]
      },
      egyeb_prognosztika: {
        key: 'egyeb_prognosztika',
        type: 'three_state',
        label: 'Egyéb prognosztikai tényezők vizsgálata történt-e?',
        validation: null,
        dependency: null
      },
      csontvelo_elegtelenseg: {
        key: 'csontvelo_elegtelenseg',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Csontvelő elégtelenség/transzfúzió típusa',
        validation: null,
        dependency: [{bno: ['CLL']}]
      },
      fertozes_elozm_korlef_soran: {
        key: 'fertozes_elozm_korlef_soran',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Fertőzés előzményi kórlefolyás során: fertőzés típusa (ha egyéb, akkor a Fertőzés előzményi kórlefolyás során: egyéb fertőzéstípus (szövegesen megadva) mezőben megadható)',
        validation: null,
        dependency: [{bno: ['CLL']}]
      },
      fertozes_eloz_kf_soran_egyeb: {
        key: 'fertozes_eloz_kf_soran_egyeb',
        type: 'text',
        label: 'Fertőzés előzményi kórlefolyás során: egyéb fertőzéstípus (szövegesen megadva)',
        validation: [{maxLength: 500}],
        dependency: [{hasContent: 'fertozes_elozm_korlef_soran'}, {elementsOf: ['fertozes_elozm_korlef_soran', ["99"]] }]
      },
      szovettan_vizsgalat: {
        key: 'szovettan_vizsgalat',
        type: 'three_state',
        label: 'Szövettani vizsgálat történt-e?',
        validation: null,
        dependency: null
      },
      szovettan_mintavetel_helye: {
        key: 'szovettan_mintavetel_helye',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Szövettani vizsgálat: a mintavétel helye (ha egyéb, akkor a Szövettani vizsgálat: egyéb mintavétel helye (szövegesen megadva) mezőben megadható)',
        validation: null,
        dependency: [{hasContent: 'szovettan_vizsgalat'}, {elementsOf: ['szovettan_vizsgalat', [2]] }]
      },
      szovettan_mintavet_helye_egyeb: {
        key: 'szovettan_mintavet_helye_egyeb',
        type: 'text',
        label: 'Szövettani vizsgálat: egyéb mintavétel helye (szövegesen megadva)',
        validation: [{maxLength: 200}],
        dependency: [{hasContent: 'szovettan_mintavetel_helye'}, {elementsOf: ['szovettan_mintavetel_helye', ["99"]] }]
      },
      szovettan_vizsgalat_datuma: {
        key: 'szovettan_vizsgalat_datuma',
        type: 'date',
        label: 'Szövettani vizsgálat dátuma',
        validation: [{type: 'date'}],
        dependency: [{hasContent: 'szovettan_vizsgalat'}, {elementsOf: ['szovettan_vizsgalat', [2]] }]
      },
      autoimmun_szovodmeny: {
        key: 'autoimmun_szovodmeny',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Autoimmun szövődmény típusa',
        validation: null,
        dependency: [{bno: ['CLL']}]
      },
      masodlagos_malignitasok: {
        key: 'masodlagos_malignitasok',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Másodlagos malignitások típusa (ha egyéb, akkor a Másodlagos malignitások: egyéb típus (szövegesen megadva) mezőben megadható)',
        recommended: true,
        validation: null,
        dependency: null
      },
      masodlagos_malignitasok_egyeb: {
        key: 'masodlagos_malignitasok_egyeb',
        type: 'text',
        label: 'Másodlagos malignitások: egyéb típus (szövegesen megadva)',
        validation: [{maxLength: 200}],
        dependency: [{hasContent: 'masodlagos_malignitasok'}, {elementsOf: ['masodlagos_malignitasok', ["99"]] }]
      },
      diagnozis_forrasa: {
        key: 'diagnozis_forrasa',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'A diagnózis forrása',
        validation: null,
        dependency: [{hasContent: 'masodlagos_malignitasok'}, {elementsOf: ['masodlagos_malignitasok', ["11", "12", "13", "14", "15", "16", "17"]] }]
      },
    },
    labor: {
      virus_szerologia_anti_hcv: {
        key: 'virus_szerologia_anti_hcv',
        type: 'three_state',
        label: 'Vírus szerológia: antiHCV',
        validation: null,
        dependency: null
      },
      virus_szerologia_anti_hbc: {
        key: 'virus_szerologia_anti_hbc',
        type: 'three_state',
        label: 'Vírus szerológia: antiHBc',
        validation: null,
        dependency: null
      },
      virus_szerologia_hbsag: {
        key: 'virus_szerologia_hbsag',
        type: 'three_state',
        label: 'Vírus szerológia: HBsAg',
        validation: null,
        dependency: null
      },
      virus_szerologia_hiv: {
        key: 'virus_szerologia_hiv',
        type: 'three_state',
        label: 'Vírus szerológia: HIV jelen van?',
        validation: null,
        dependency: null
      },
      fk_nehezlanc_tipusa: {
        key: 'fk_nehezlanc_tipusa',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Fehérjekémia: nehézlánc típusa',
        validation: null,
        dependency: [{bno: ['MM']}]
      },
      fk_nl_paraprotein_menny: {
        key: 'fk_nl_paraprotein_menny',
        type: 'labor',
        label: 'Fehérjekémia: nehézlánc paraprotein mennyisége (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['MM']}]
      },
      fk_konnyulanc_tipusa: {
        key: 'fk_konnyulanc_tipusa',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Fehérjekémia: könnyűlánc típusa',
        validation: null,
        dependency: [{bno: ['MM']}]
      },
      fk_szabad_kl_menny_savoban: {
        key: 'fk_szabad_kl_menny_savoban',
        type: 'labor',
        label: 'Fehérjekémia: szabad könnyűlánc mennyisége savóban (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['MM']}]
      },
      fk_kappa_lambda_arany: {
        key: 'fk_kappa_lambda_arany',
        type: 'labor',
        label: 'Fehérjekémia: kappa/lambda arány savóban',
        validation: 'labor',
        dependency: [{bno: ['MM']}]
      },
      fk_bence_jones_proteinura: {
        key: 'fk_bence_jones_proteinura',
        type: 'three_state',
        label: 'Fehérjekémia: Bence-Jones proteinura',
        validation: null,
        dependency: [{bno: ['MM']}]
      },
      fk_b_j_prot_menny: {
        key: 'fk_b_j_prot_menny',
        type: 'text',
        label: 'Fehérjekémia: Bence-Jones proteinura mennyisége',
        validation: [{type: 'number'}, {hasContent: 'fk_b_j_prot_mertekegyseg'}],
        dependency: [{hasContent: 'fk_bence_jones_proteinura'}, {elementsOf: ['fk_bence_jones_proteinura', [2]] }]
      },
      fk_b_j_prot_mertekegyseg: {
        key: 'fk_b_j_prot_mertekegyseg',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Fehérjekémia: Bence-Jones proteinura mértékegysége',
        validation: [{hasContent: 'fk_b_j_prot_menny'}],
        validationText: 'Kötelezően szám mező',
        dependency: [{hasContent: 'fk_bence_jones_proteinura'}, {elementsOf: ['fk_bence_jones_proteinura', [2]] }]
      },
      fk_amyloid_tipusa: {
        key: 'fk_amyloid_tipusa',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Fehérjekémia: amyloid típusa',
        validation: null,
        dependency: [{bno: ['MM']}]
      },
      citogenetikai_vizsgalat: {
        key: 'citogenetikai_vizsgalat',
        type: 'three_state',
        label: 'Cito-/molekuláris genetikai vizsgálat történt-e?',
        validation: null,
        dependency: [{bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      citogenetikai_elteres: {
        key: 'citogenetikai_elteres',
        type: 'three_state',
        label: 'Cito-/molekuláris genetikai vizsgálat során cytogenetikai eltérés volt-e?',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_vizsgalat'}, {elementsOf: ['citogenetikai_vizsgalat', [2]] }]
      },
      citogenetika_hypodiploiditas: {
        key: 'citogenetika_hypodiploiditas',
        type: 'three_state',
        label: 'Citogenetika: hypodiploiditas van-e?',
        validation: [{onlyIf: [[2], 'citogenetika_hyperdiploiditas', [null, 1, 3]]}],
        validationText: 'Csak akkor lehet Igen, ha a Citogenetika: hyperdiploiditas mező nem Igen értékű',
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['AL']}]
      },
      citogenetika_hypodip_tipus: {
        key: 'citogenetika_hypodip_tipus',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Citogenetika: hypodiploiditas típusa',
        validation: null,
        dependency: [{hasContent: 'citogenetika_hypodiploiditas'}, {elementsOf: ['citogenetika_hypodiploiditas', [2]] }, {bno: ['AL']}]
      },
      citogenetika_hyperdiploiditas: {
        key: 'citogenetika_hyperdiploiditas',
        type: 'three_state',
        label: 'Citogenetika: hyperdiploiditas van-e?',
        validation: [{onlyIf: [[2], 'citogenetika_hypodiploiditas', [null, 1, 3]]}],
        validationText: 'Csak akkor lehet Igen, ha a Citogenetika: hypodiploiditas mező nem Igen értékű',
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['AL']}]
      },
      citogenetika_hyperdip_tipus: {
        key: 'citogenetika_hyperdip_tipus',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Citogenetika: hyperdiploiditas típusa',
        validation: null,
        dependency: [{hasContent: 'citogenetika_hyperdiploiditas'}, {elementsOf: ['citogenetika_hyperdiploiditas', [2]] }, {bno: ['AL']}]
      },
      citogenetika_komplex_karyotipus: {
        key: 'citogenetika_komplex_karyotipus',
        type: 'three_state',
        label: 'citogenetika: komplex karyotípus jelen van-e?',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['AL']}]
      },
      citogenetika_diag_eltero_abnorm: {
        key: 'citogenetika_diag_eltero_abnorm',
        type: 'text',
        label: 'Citogenetika: diagnózisban foglalttól eltérő egyéb vagy társult abnormalitások leírása',
        validation: [{maxLength: 500}],
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['AL']}]
      },
      citogenetika_del_6q: {
        key: 'citogenetika_del_6q',
        type: 'three_state',
        label: 'Citogenetika: del 6q',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['CLL']}]
      },
      citogenetika_del_11q22_23: {
        key: 'citogenetika_del_11q22_23',
        type: 'three_state',
        label: 'Citogenetika: del 11q22-23',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['CLL']}]
      },
      citogenetika_del_13: {
        key: 'citogenetika_del_13',
        type: 'three_state',
        label: 'Citogenetika: del 13',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['MM']}]
      },
      citogenetika_del_13p14: {
        key: 'citogenetika_del_13p14',
        type: 'three_state',
        label: 'Citogenetika: del 13p14',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['CLL']}]
      },
      citogenetika_del_17p13: {
        key: 'citogenetika_del_17p13',
        type: 'three_state',
        label: 'citogenetika: del 17p13',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['CLL', 'MM']}]
      },
      citogenetika_del_17p14: {
        key: 'citogenetika_del_17p14',
        type: 'three_state',
        label: 'Citogenetika: del 17p14',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['CLL']}]
      },
      citogenetika_t_4_14: {
        key: 'citogenetika_t_4_14',
        type: 'three_state',
        label: 'Citogenetika: t(4;14)',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['MM']}]
      },
      citogenetika_t_11_14: {
        key: 'citogenetika_t_11_14',
        type: 'three_state',
        label: 'Citogenetika: t(11;14)',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['MM']}]
      },
      citogenetika_t_14_16: {
        key: 'citogenetika_t_14_16',
        type: 'three_state',
        label: 'Citogenetika: t(14;16)',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['MM']}]
      },
      citogenetika_t_14_20: {
        key: 'citogenetika_t_14_20',
        type: 'three_state',
        label: 'Citogenetika: t(14;20)',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['MM']}]
      },
      citogenetika_1q21_amplifikacio: {
        key: 'citogenetika_1q21_amplifikacio',
        type: 'three_state',
        label: 'Citogenetika: 1q21 amplifikáció',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['MM']}]
      },
      citogenetika_1p_abnormalitas: {
        key: 'citogenetika_1p_abnormalitas',
        type: 'three_state',
        label: 'Citogenetika: 1p abnormalitás',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['MM']}]
      },
      citogenetika_12_es_triszomia: {
        key: 'citogenetika_12_es_triszomia',
        type: 'three_state',
        label: 'Citogenetika: 12-es triszómia',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['CLL', 'MM']}]
      },
      citogenetika_ighdel: {
        key: 'citogenetika_ighdel',
        type: 'three_state',
        label: 'Citogenetika: IgHdel',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['CLL']}]
      },
      citogenetika_norm_fish: {
        key: 'citogenetika_norm_fish',
        type: 'three_state',
        label: 'citogenetika: norm. FISH',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['CLL', 'NHL']}]
      },
      citogenetika_egyeb: {
        key: 'citogenetika_egyeb',
        type: 'three_state',
        label: 'Citogenetika: egyéb marker volt-e?',
        validation: null,
        dependency: [{hasContent: 'citogenetikai_elteres'}, {elementsOf: ['citogenetikai_elteres', [2]] }, {bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      citogenetika_egyeb_megnevezes: {
        key: 'citogenetika_egyeb_megnevezes',
        type: 'text',
        label: 'Citogenetika: egyéb marker megnevezése',
        validation: [{maxLength: 200}],
        dependency: [{hasContent: 'citogenetika_egyeb'}, {elementsOf: ['citogenetika_egyeb', [2]] }, {bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      immunofenotipus_ver: {
        key: 'immunofenotipus_ver',
        type: 'three_state',
        label: 'Immunofenotípus: vér',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunof_ver_klonok_sz_diag: {
        key: 'immunof_ver_klonok_sz_diag',
        type: 'text',
        label: 'Immunofenotípus: vér: klónok száma diagnóziskor',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_ver'}, {elementsOf: ['immunofenotipus_ver', [2]] }]
      },
      immunof_ver_klonok_sz_remi: {
        key: 'immunof_ver_klonok_sz_remi',
        type: 'text',
        label: 'Immunofenotípus: vér: klónok száma morfológiai remisszióban',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_ver'}, {elementsOf: ['immunofenotipus_ver', [2]] }]
      },
      immunof_ver_klonok_sz_rela: {
        key: 'immunof_ver_klonok_sz_rela',
        type: 'text',
        label: 'Immunofenotípus: vér: klónok száma morfológiai relapszusban',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_ver'}, {elementsOf: ['immunofenotipus_ver', [2]] }]
      },
      immunofenotipus_csontvelo: {
        key: 'immunofenotipus_csontvelo',
        type: 'three_state',
        label: 'Immunofenotípus: csontvelő',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunof_csontvelo_klonok_sz_diag: {
        key: 'immunof_csontvelo_klonok_sz_diag',
        type: 'text',
        label: 'Immunofenotípus: csontvelő: klónok száma diagnóziskor',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_csontvelo'}, {elementsOf: ['immunofenotipus_csontvelo', [2]] }]
      },
      immunof_csontvelo_klonok_sz_remi: {
        key: 'immunof_csontvelo_klonok_sz_remi',
        type: 'text',
        label: 'Immunofenotípus: csontvelő: klónok száma morfológiai remisszióban',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_csontvelo'}, {elementsOf: ['immunofenotipus_csontvelo', [2]] }]
      },
      immunof_csontvelo_klonok_sz_rela: {
        key: 'immunof_csontvelo_klonok_sz_rela',
        type: 'text',
        label: 'Immunofenotípus: csontvelő: klónok száma morfológiai relapszusban',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_csontvelo'}, {elementsOf: ['immunofenotipus_csontvelo', [2]] }]
      },
      immunofenotipus_liquor: {
        key: 'immunofenotipus_liquor',
        type: 'three_state',
        label: 'Immunofenotípus: liquor',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunof_liquor_klonok_sz_diag: {
        key: 'immunof_liquor_klonok_sz_diag',
        type: 'text',
        label: 'Immunofenotípus: liquor: klónok száma diagnóziskor',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_liquor'}, {elementsOf: ['immunofenotipus_liquor', [2]] }]
      },
      immunof_liquor_klonok_sz_remi: {
        key: 'immunof_liquor_klonok_sz_remi',
        type: 'text',
        label: 'Immunofenotípus: liquor: klónok száma morfológiai remisszióban',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_liquor'}, {elementsOf: ['immunofenotipus_liquor', [2]] }]
      },
      immunof_liquor_klonok_sz_rela: {
        key: 'immunof_liquor_klonok_sz_rela',
        type: 'text',
        label: 'Immunofenotípus: liquor: klónok száma morfológiai relapszusban',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_liquor'}, {elementsOf: ['immunofenotipus_liquor', [2]] }]
      },
      immunofenotipus_szovetminta: {
        key: 'immunofenotipus_szovetminta',
        type: 'three_state',
        label: 'Immunofenotípus: szövetminta',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunof_szovetminta_klon_sz_diag: {
        key: 'immunof_szovetminta_klon_sz_diag',
        type: 'text',
        label: 'Immunofenotípus: szövetminta: klónok száma diagnóziskor',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_szovetminta'}, {elementsOf: ['immunofenotipus_szovetminta', [2]] }]
      },
      immunof_szovetminta_klon_sz_remi: {
        key: 'immunof_szovetminta_klon_sz_remi',
        type: 'text',
        label: 'Immunofenotípus: szövetminta: klónok száma morfológiai remisszióban',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_szovetminta'}, {elementsOf: ['immunofenotipus_szovetminta', [2]] }]
      },
      immunof_szovetminta_klon_sz_rela: {
        key: 'immunof_szovetminta_klon_sz_rela',
        type: 'text',
        label: 'Immunofenotípus: szövetminta: klónok száma morfológiai relapszusban',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofenotipus_szovetminta'}, {elementsOf: ['immunofenotipus_szovetminta', [2]] }]
      },
      immunofen_1_klon_leuk_asszoc: {
        key: 'immunofen_1_klon_leuk_asszoc',
        type: 'three_state',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 1. klón jelen van-e?',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_1_klon: {
        key: 'immunofen_1_klon',
        type: 'text',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 1. klón jellemzője',
        validation: [{maxLength: 200}],
        dependency: [{hasContent: 'immunofen_1_klon_leuk_asszoc'}, {elementsOf: ['immunofen_1_klon_leuk_asszoc', [2]] }]
      },
      immunofen_1_klon_szazalek: {
        key: 'immunofen_1_klon_szazalek',
        type: 'text',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 1. klón %-os arány',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_1_klon_leuk_asszoc'}, {elementsOf: ['immunofen_1_klon_leuk_asszoc', [2]] }]
      },
      immunofen_2_klon_leuk_asszoc: {
        key: 'immunofen_2_klon_leuk_asszoc',
        type: 'three_state',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 2. klón jelen van-e? ',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_2_klon: {
        key: 'immunofen_2_klon',
        type: 'text',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 2. klón jellemzője',
        validation: [{maxLength: 200}],
        dependency: [{hasContent: 'immunofen_2_klon_leuk_asszoc'}, {elementsOf: ['immunofen_2_klon_leuk_asszoc', [2]] }]
      },
      immunofen_2_klon_szazalek: {
        key: 'immunofen_2_klon_szazalek',
        type: 'text',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 2. klón %-os arány',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_2_klon_leuk_asszoc'}, {elementsOf: ['immunofen_2_klon_leuk_asszoc', [2]] }]
      },
      immunofen_3_klon_leuk_asszoc: {
        key: 'immunofen_3_klon_leuk_asszoc',
        type: 'three_state',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 3. klón jelen van-e? ',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_3_klon: {
        key: 'immunofen_3_klon',
        type: 'text',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 3. klón jellemzője',
        validation: [{maxLength: 200}],
        dependency: [{hasContent: 'immunofen_3_klon_leuk_asszoc'}, {elementsOf: ['immunofen_3_klon_leuk_asszoc', [2]] }]
      },
      immunofen_3_klon_szazalek: {
        key: 'immunofen_3_klon_szazalek',
        type: 'text',
        label: 'Immunofenotípus: leukémia-asszociált immunfenotípus: 3. klón %-os arány',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_3_klon_leuk_asszoc'}, {elementsOf: ['immunofen_3_klon_leuk_asszoc', [2]] }]
      },
      immunofen_cd1a: {
        key: 'immunofen_cd1a',
        type: 'three_state',
        label: 'Immunofenotípus: CD1a marker jelen van?',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_cd1a_szazalek: {
        key: 'immunofen_cd1a_szazalek',
        type: 'text',
        label: 'Immunofenotípus: CD1a marker %-os aránya',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_cd1a'}, {elementsOf: ['immunofen_cd1a', [2]] }]
      },
      immunofen_cd19p: {
        key: 'immunofen_cd19p',
        type: 'three_state',
        label: 'Immunofenotípus: C19 marker jelen van?',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_cd19p_szazalek: {
        key: 'immunofen_cd19p_szazalek',
        type: 'text',
        label: 'Immunofenotípus: C19 marker %-os aránya',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_cd19p'}, {elementsOf: ['immunofen_cd19p', [2]] }]
      },
      immunofen_cd20p: {
        key: 'immunofen_cd20p',
        type: 'three_state',
        label: 'Immunofenotípus: C20 marker jelen van?',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_cd20p_szazalek: {
        key: 'immunofen_cd20p_szazalek',
        type: 'text',
        label: 'Immunofenotípus: C20 marker %-os aránya',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_cd20p'}, {elementsOf: ['immunofen_cd20p', [2]] }]
      },
      immunofen_cd22p: {
        key: 'immunofen_cd22p',
        type: 'three_state',
        label: 'Immunofenotípus: C22 marker jelen van?',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_cd22p_szazalek: {
        key: 'immunofen_cd22p_szazalek',
        type: 'text',
        label: 'Immunofenotípus: C22 marker %-os aránya',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_cd22p'}, {elementsOf: ['immunofen_cd22p', [2]] }]
      },
      immunofen_cd56p: {
        key: 'immunofen_cd56p',
        type: 'three_state',
        label: 'Immunofenotípus: C56 marker jelen van?',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_cd56p_szazalek: {
        key: 'immunofen_cd56p_szazalek',
        type: 'text',
        label: 'Immunofenotípus: C56 marker %-os aránya',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_cd56p'}, {elementsOf: ['immunofen_cd56p', [2]] }]
      },
      immunofen_cd123p: {
        key: 'immunofen_cd123p',
        type: 'three_state',
        label: 'Immunofenotípus: C123 marker jelen van?',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_cd123p_szazalek: {
        key: 'immunofen_cd123p_szazalek',
        type: 'text',
        label: 'Immunofenotípus: C123 marker %-os aránya',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_cd123p'}, {elementsOf: ['immunofen_cd123p', [2]] }]
      },
      immunofen_limfoid_marker: {
        key: 'immunofen_limfoid_marker',
        type: 'three_state',
        label: 'Immunofenotípus: limfoid marker jelen van?',
        validation: null,
        dependency: [{bno: ['AL']}]
      },
      immunofen_limf_marker_megn: {
        key: 'immunofen_limf_marker_megn',
        type: 'text',
        label: 'Immunofenotípus: limfoid marker megnevezése',
        validation: [{maxLength: 200}],
        dependency: [{hasContent: 'immunofen_limfoid_marker'}, {elementsOf: ['immunofen_limfoid_marker', [2]] }]
      },
      immunofen_limf_mark_szazalek: {
        key: 'immunofen_limf_mark_szazalek',
        type: 'text',
        label: 'Immunofenotípus: limfoid marker %-os aránya',
        validation: [{type: 'number'}],
        dependency: [{hasContent: 'immunofen_limfoid_marker'}, {elementsOf: ['immunofen_limfoid_marker', [2]] }]
      },
      verkep_feherversejt: {
        key: 'verkep_feherversejt',
        type: 'labor',
        label: 'Vérkép: fehérvérsejt értéke (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      verkep_abszolut_granulo: {
        key: 'verkep_abszolut_granulo',
        type: 'labor',
        label: 'Vérkép: abszolút granulocyta értéke (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      verkep_hemoglobin: {
        key: 'verkep_hemoglobin',
        type: 'labor',
        label: 'Vérkép: hemoglobin értéke (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      verkep_hematocrit: {
        key: 'verkep_hematocrit',
        type: 'labor',
        label: 'Vérkép: hematocrit értéke',
        validation: 'labor',
        dependency: [{bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      verkep_thrombocyta: {
        key: 'verkep_thrombocyta',
        type: 'labor',
        label: 'Vérkép: thrombocyta értéke (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['AL', 'MM', 'NHL']}]
      },
      verkep_blasztarany_ver: {
        key: 'verkep_blasztarany_ver',
        type: 'labor',
        label: 'Vérkép: blasztarány értéke vérben (például: %)',
        validation: 'labor',
        dependency: [{bno: ['AL']}]
      },
      verkep_blasztarany_csontv: {
        key: 'verkep_blasztarany_csontv',
        type: 'labor',
        label: 'Vérkép: blasztarány értéke csontvelőben (például: %)',
        validation: 'labor',
        dependency: [{bno: ['AL']}]
      },
      laktat_dehidrogenaz: {
        key: 'laktat_dehidrogenaz',
        type: 'labor',
        label: 'Laktát dehidrogenáz értéke (például: IU/l)',
        validation: 'labor',
        dependency: [{bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      immuglobulin_g: {
        key: 'immuglobulin_g',
        type: 'labor',
        label: 'Immunoglobulin G értéke (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['CLL']}]
      },
      immuglobulin_a: {
        key: 'immuglobulin_a',
        type: 'labor',
        label: 'Immunoglobulin A értéke (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['CLL']}]
      },
      immuglobulin_m: {
        key: 'immuglobulin_m',
        type: 'labor',
        label: 'Immunoglobulin M értéke (például: g/l)',
        validation: 'labor',
        dependency: [{bno: ['CLL']}]
      },
      szerum_beta_2_microglob: {
        key: 'szerum_beta_2_microglob',
        type: 'labor',
        label: 'Szérum: béta-2-microglobulin értéke (például: mmol/l)',
        validation: 'labor',
        dependency: [{bno: ['CLL']}]
      },
      szerum_hugysav: {
        key: 'szerum_hugysav',
        type: 'labor',
        label: 'Szérum: húgysav értéke (például: mmol/l)',
        validation: 'labor',
        dependency: [{bno: ['AL', 'MM', 'NHL']}]
      },
      szerum_kalcium: {
        key: 'szerum_kalcium',
        type: 'labor',
        label: 'Szérum: kalcium értéke (például: mmol/l)',
        validation: 'labor',
        dependency: [{bno: ['MM']}]
      },
      szerum_kreatinin: {
        key: 'szerum_kreatinin',
        type: 'labor',
        label: 'Szérum: kreatinin értéke (például: mmol/l)',
        validation: 'labor',
        dependency: [{bno: ['MM']}]
      },
      szerum_osszfeherje: {
        key: 'szerum_osszfeherje',
        type: 'labor',
        label: 'Szérum: összfehérje értéke (például: mmol/l)',
        validation: 'labor',
        dependency: [{bno: ['MM']}]
      },
      mol_gen_ighv_mutacio_statusz: {
        key: 'mol_gen_ighv_mutacio_statusz',
        type: 'search_list',
        get_value_from_backend: true,
        label: 'Molekuláris genetika: igHV mutációs státusz',
        validation: null,
        dependency: [{bno: ['CLL']}]
      },
      mol_gen_p53_mutacio: {
        key: 'mol_gen_p53_mutacio',
        type: 'three_state',
        label: 'Molekuláris genetika: p53 mutáció jelen van-e?',
        validation: null,
        dependency: [{bno: ['CLL']}]
      },
      flow_citometria: {
        key: 'flow_citometria',
        type: 'three_state',
        label: 'Flow-cytometriai vizsgálat történt-e?',
        validation: null,
        dependency: [{bno: ['AL', 'CLL', 'MM', 'NHL']}]
      },
      flow_cito_immunfenotipus: {
        key: 'flow_cito_immunfenotipus',
        type: 'text',
        label: 'Flow-cytometria: immunfenotípus megnevezése',
        validation: [{maxLength: 300}],
        dependency: [{hasContent: 'flow_citometria'}, {elementsOf: ['flow_citometria', [2]] }]
      }
    }
  },
  betegseg_kimenetel: {
    kezelesre_adott_legjobb_valasz: {
      key: 'kezelesre_adott_legjobb_valasz',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'A kezelésre adott legjobb válasz',
      recommended: true,
      validation: null,
      dependency: null
    },
    deauville_score: {
      key: 'deauville_score',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'Deauville score kategória',
      validation: null,
      dependency: [{bno: ['HL']}]
    },
    renalis_valasz: {
      key: 'renalis_valasz',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'Renális válasz',
      validation: null,
      dependency: [{bno: ['MM']}]
    },
    halal: {
      key: 'halal',
      type: 'three_state',
      label: 'A beteg elhunyt?',
      recommended: true,
      validation: null,
      dependency: null
    },
    halal_datuma: {
      key: 'halal_datuma',
      type: 'date',
      label: 'A halál időpontja',
      recommended: true,
      validation: [{type: 'date'}],
      dependency: [{hasContent: 'halal'}, {elementsOf: ['halal', [2]] }]
    },
    halal_oka: {
      key: 'halal_oka',
      type: 'text',
      label: 'A halál oka',
      validation: [{maxLength: 200}],
      dependency: [{hasContent: 'halal'}, {elementsOf: ['halal', [2]] }]
    },
    halal_oka_koddal: {
      key: 'halal_oka_koddal',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'A halál oka kódolva',
      recommended: true,
      validation: null,
      dependency: [{hasContent: 'halal'}, {elementsOf: ['halal', [2]] }]
    },
    toxicitas_leirasa: {
      key: 'toxicitas_leirasa',
      type: 'text',
      label: 'Toxicitás leírása',
      validation: [{maxLength: 300}],
      dependency: null
    },
    boncolas_adatai: {
      key: 'boncolas_adatai',
      type: 'text',
      label: 'A boncolás adatai',
      validation: [{maxLength: 5000}],
      dependency: [{hasContent: 'halal'}, {elementsOf: ['halal', [2]] }]
    }
  },
  tovabbi_kezeles: {
    tovabbi_kezeles: {
      key: 'tovabbi_kezeles',
      type: 'search_list',
      get_value_from_backend: true,
      label: 'A további kezelés típusának kódja ',
      recommended: true,
      validation: null,
      dependency: null
    }
  }
}
